import { useEffect } from "react";
import markerSDK from "@marker.io/browser";
import { getMarkerProjectId } from "./getMarkerProjectId";

type UseMarkerIOParams = {
	env?: string;
};

/** Loads the Marker.io feedback widget on non-local environments. */
export const useMarkerIO = ({ env }: UseMarkerIOParams) => {
	useEffect(() => {
		if (!env || window.location.hostname.includes("localhost")) {
			return;
		}

		const projectId = getMarkerProjectId(env);

		if (!projectId) {
			return;
		}

		const releaseName = window.__VERSION__;

		markerSDK.loadWidget({
			project: projectId,
			silent: true,
			customData: releaseName ? { releaseName } : undefined,
		});
	}, [env]);
};
